<template>
  <div>
    <loading v-if="loading" />
    <template v-else>
      <table
        v-if="wallets.length"
        class="table table-striped table-responsive-sm"
      >
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in wallets"
            :key="i"
          >
            <td>{{ i + 1 }}</td>
            <td>{{ item.company }}</td>
            <td>KES {{ $number.format(item.balance) }}</td>
          </tr>
        </tbody>
      </table>
      <div
        v-else
        class="alert alert-warning"
      >
        <p>There are no wallets</p>
      </div>
    </template>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {
      wallets: [],
      loading: true
    }
  },
  watch: {
    wallets() {
      setTimeout(() => {
        $('.table').DataTable();
      }, 1000);
    }
  },
  mounted() {
    this.fetchwallets();
  },
  methods: {
    fetchwallets() {
      this.loading = true;
      this.$axios.get('/api/v1/wallets').then(response => {
        this.loading = false;
        this.wallets = response.data;
      });
    },
  }
}
</script>
